import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";
import { euro } from "./rUtils";

const num = (v) => Number(String(v || 0).replace(",", ".")) || 0;
export const linesTotal = (lines) => lines.reduce((s, l) => s + num(l.unit_price) * (Number(l.quantity) || 0), 0);

export function LinesEditor({ lines, onChange, testId = "lines" }) {
  const set = (i, k, v) => onChange(lines.map((l, j) => (j === i ? { ...l, [k]: v } : l)));
  return (
    <div className="space-y-2" data-testid={testId}>
      {lines.map((l, i) => (
        <div key={i} className="grid grid-cols-[1fr_64px_96px_28px] gap-2 items-center">
          <Input value={l.description} onChange={(e) => set(i, "description", e.target.value)} placeholder="Leistungsbeschreibung" className="bg-[#0A0A0A] border-white/20 text-white" data-testid={`${testId}-desc-${i}`} />
          <Input type="number" min={1} value={l.quantity} onChange={(e) => set(i, "quantity", e.target.value)} className="bg-[#0A0A0A] border-white/20 text-white" data-testid={`${testId}-qty-${i}`} />
          <Input value={l.unit_price} onChange={(e) => set(i, "unit_price", e.target.value)} placeholder="Einzelpreis" className="bg-[#0A0A0A] border-white/20 text-white" data-testid={`${testId}-price-${i}`} />
          <button type="button" onClick={() => onChange(lines.filter((_, j) => j !== i))} disabled={lines.length === 1} className="text-[#71717A] hover:text-red-400 disabled:opacity-30"><Trash2 className="w-4 h-4" /></button>
        </div>
      ))}
      <div className="flex justify-between items-center">
        <button type="button" onClick={() => onChange([...lines, { description: "", quantity: 1, unit_price: "0.00" }])} className="text-xs text-[#c1ff72] flex items-center gap-1" data-testid={`${testId}-add`}><Plus className="w-3.5 h-3.5" />Position</button>
        <span className="text-white font-semibold" data-testid={`${testId}-total`}>Gesamt: {euro(linesTotal(lines))}</span>
      </div>
    </div>
  );
}

export const toLineIn = (lines) => lines.map((l) => ({ description: l.description, quantity: Number(l.quantity) || 1, unit_price: String(l.unit_price).replace(",", ".") }));
